// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"a675f8e1bffa2b12c241","993":"04f745044241015e0aa1"}[chunkId] + ".js");